import cdnPath from './cdnPath';
export default cdnPath;